// extracted by mini-css-extract-plugin
export default {"container":"components_container__cDPbZ","icon":"components_icon__3MNov"};